import { Subscription } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { DeleteConfirmDialogComponent } from 'src/app/common/modules/shared/components/delete-confirm-dialog/deleteConfirmDialog.component';
import { AuthService } from 'src/app/common/services/auth/auth.service';
import { IFaq } from 'src/app/common/model/support.model';
import { FaqService } from 'src/app/common/services/faq/faq.service';

@Component({
  selector: 'app-faqs-list',
  templateUrl: './faqs-list.component.html',
  styleUrls: ['./faqs-list.component.scss'],
  providers: [DialogService, MessageService, ConfirmationService]
})
export class FAQsListComponent implements OnInit {
  subscriptions = new Subscription();
  faqs: IFaq[] = [];

  constructor(
    private faqService: FaqService,
    public dialogService: DialogService,
    public authService: AuthService
  ) {}

  ngOnInit(): void {
    this.getAllFaqs();
  }

  getAllFaqs(): void {
    this.subscriptions.add(
      this.faqService.getAllFaqs().subscribe({
        next: (res) => {
          this.faqs =
            res?.result?.length > 0
              ? res.result.map((x) => this.appendDropdownItemsToItem(x))
              : [];
        }
      })
    );
  }
  public deleteConfirm(item: any) {
    const ref = this.dialogService.open(DeleteConfirmDialogComponent, {
      header: 'Delete Confirmation',
      width: '50%',
      baseZIndex: 10000
    });
    ref.onClose.subscribe((confirm) => {
      if (confirm) {
        this.deleteFaq(item?._id);
      }
    });
  }
  deleteFaq(faqId: string): void {
    this.subscriptions.add(
      this.faqService.deleteFaq(faqId).subscribe({
        complete: () => this.getAllFaqs()
      })
    );
  }
  appendDropdownItemsToItem(item: IFaq) {
    const menuItems = [
      {
        label: 'Update',
        icon: 'pi pi-pencil',
        routerLink: ['../edit-faq/' + item?._id]
      },
      {
        label: 'Delete',
        icon: 'pi pi-times',
        command: () => {
          this.deleteConfirm(item);
        }
      }
    ];
    item.menuItems = menuItems;
    return item;
  }
}
